import { render, staticRenderFns } from "./GiveAwayMerchants.vue?vue&type=template&id=ace9076a"
import script from "./GiveAwayMerchants.vue?vue&type=script&lang=js"
export * from "./GiveAwayMerchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports